import React, { Component } from "react";
import styled from "styled-components";
import { withRouter } from "react-router-dom";

class NavigationBarContainer extends Component {
  constructor(props, context) {
    super(props, context);
  
    this.state = {
      pick: "",
      menuVisible: false,
      serviceDropdownVisible: false,
      dropdownTimeout: null
    };
  }

  // 드롭다운 표시 함수
  showDropdown = () => {
    // 이미 실행 중인 타이머가 있다면 취소
    if (this.state.dropdownTimeout) {
      clearTimeout(this.state.dropdownTimeout);
    }
    this.setState({ serviceDropdownVisible: true, dropdownTimeout: null });
  };

  // 드롭다운 숨김 함수 (지연 시간 추가)
  hideDropdown = () => {
    // 타이머 설정하여 지연 후 숨김
    const timeout = setTimeout(() => {
      this.setState({ serviceDropdownVisible: false, dropdownTimeout: null });
    }, 300); // 300ms 지연
    
    this.setState({ dropdownTimeout: timeout });
  };

  renderMobileClose = () => {
    this.setState({
      menuVisible: false,
    });
  };
  
  renderMobileMenu = () => {
    return (
      <TempMenu>
        <MmenuImg
          src={require("../../aimg/mmenu.png")}
          alt="mmenu.png"
          onClick={() => {
            this.setState({
              menuVisible: true,
            });
          }}
        />
        {this.state.menuVisible === true ? this.rederModal() : null}
      </TempMenu>
    );
  };
  
  rederModal = () => {
    return (
      <React.Fragment>
        <ModelOverlay />
        <MobileHalf>
          <ModalMenuContainer>
            <MImgDiv>
              <ModalInGraLogoImg
                src={require("../../aimg/logo.png")}
                alt="mModalLogo.png"
                onClick={() => {
                  this.renderMobileClose();
                  this.props.history.push("/");
                }}
              />
              <MXmenuImg
                src={require("../../aimg/mXmenu.png")}
                alt="mXmenu.png"
                onClick={() => {
                  this.setState({
                    menuVisible: "",
                  });
                }}
              />
              {this.state.menuVisible === "" ? (
                <MXmenuImg style={{ display: "none" }} />
              ) : null}
            </MImgDiv>
            <ModalLine />
            <ModalMenuDiv>
              <MobileMenuText
                pick={this.state.pick}
                onClick={() => {
                  this.setState({
                    pick: "COMPANY",
                  });
                  this.renderMobileClose();
                  this.props.history.push("/company");
                }}
              >
                COMPANY
              </MobileMenuText>

              <MobileMenuText
                pick={this.state.pick}
                onClick={() => {
                  this.setState({
                    pick: "BUSINESS",
                  });
                  this.renderMobileClose();
                  this.props.history.push("/business");
                }}
              >
                BUSINESS
              </MobileMenuText>
              
              <MobileMenuText
                pick={this.state.pick}
                onClick={() => {
                  this.setState({
                    pick: "SERVICES",
                  });
                }}
              >
                SERVICES
              </MobileMenuText>
              {this.state.pick === "SERVICES" && (
                <MobileSubmenu>
                  <MobileSubmenuItem
                    onClick={() => {
                      this.renderMobileClose();
                      this.props.history.push("/services/exchange");
                    }}
                  >
                    거래소 엔진
                  </MobileSubmenuItem>
                  <MobileSubmenuItem
                    onClick={() => {
                      this.renderMobileClose();
                      this.props.history.push("/services/deeplearning");
                    }}
                  >
                    딥러닝
                  </MobileSubmenuItem>
                  <MobileSubmenuItem
                    onClick={() => {
                      this.renderMobileClose();
                      this.props.history.push("/services/aimodeling");
                    }}
                  >
                    AI 모델링
                  </MobileSubmenuItem>
                  <MobileSubmenuItem
                    onClick={() => {
                      this.renderMobileClose();
                      this.props.history.push("/services/isms");
                    }}
                  >
                    ISMS 인증
                  </MobileSubmenuItem>
                </MobileSubmenu>
              )}
              
              <MobileMenuText
                pick={this.state.pick}
                onClick={() => {
                  this.setState({
                    pick: "NOTICE",
                  });
                  this.renderMobileClose();
                  this.props.history.push("/notice");
                }}
              >
                NOTICE
              </MobileMenuText>
              <MobileMenuText
                pick={this.state.pick}
                onClick={() => {
                  this.setState({
                    pick: "ORGANIZATION",
                  });
                  this.renderMobileClose();
                  this.props.history.push("/organization");
                }}
              >
                ORGANIZATION
              </MobileMenuText>
            </ModalMenuDiv>
          </ModalMenuContainer>
        </MobileHalf>
      </React.Fragment>
    );
  };
  
  render() {
    return (
      <NavBarContainer>
        <NavContent>
          <MobileMenuDiv>{this.renderMobileMenu()}</MobileMenuDiv>
          <NavBarLeftContainer>
            <GraLogoImg
              src={require("../../aimg/logo.png")}
              alt="logo"
              onClick={() => {
                this.setState({
                  pick: "",
                });
                this.props.history.push("/");
              }}
            />
          </NavBarLeftContainer>
          <NavBarRightContainer>
            <MenuDiv>
              <MenuText
                pick={this.state.pick}
                onClick={() => {
                  this.setState({
                    pick: "COMPANY",
                  });
                  this.props.history.push("/company");
                }}
              >
                COMPANY
              </MenuText>
              <MenuText
                pick={this.state.pick}
                onClick={() => {
                  this.setState({
                    pick: "BUSINESS",
                  });
                  this.props.history.push("/business");
                }}
              >
                BUSINESS
              </MenuText>
              
              {/* 서비스 메뉴 드롭다운 */}
              <MenuWithDropdown
                onMouseEnter={this.showDropdown}
                onMouseLeave={this.hideDropdown}
              >
                <MenuText
                  pick={this.state.pick}
                  onClick={() => {
                    this.setState({
                      pick: "SERVICES",
                      serviceDropdownVisible: !this.state.serviceDropdownVisible
                    });
                  }}
                >
                  SERVICES
                </MenuText>
                
                {this.state.serviceDropdownVisible && (
                  <DropdownMenu>
                    <DropdownItem
                      onClick={() => {
                        this.setState({
                          pick: "SERVICES",
                          serviceDropdownVisible: false
                        });
                        this.props.history.push("/services/exchange");
                      }}
                    >
                      거래소 엔진
                    </DropdownItem>
                    <DropdownItem
                      onClick={() => {
                        this.setState({
                          pick: "SERVICES",
                          serviceDropdownVisible: false
                        });
                        this.props.history.push("/services/deeplearning");
                      }}
                    >
                      딥러닝
                    </DropdownItem>
                    <DropdownItem
                      onClick={() => {
                        this.setState({
                          pick: "SERVICES",
                          serviceDropdownVisible: false
                        });
                        this.props.history.push("/services/aimodeling");
                      }}
                    >
                      AI 모델링
                    </DropdownItem>
                    <DropdownItem
                      onClick={() => {
                        this.setState({
                          pick: "SERVICES",
                          serviceDropdownVisible: false
                        });
                        this.props.history.push("/services/isms");
                      }}
                    >
                      ISMS 인증
                    </DropdownItem>
                  </DropdownMenu>
                )}
              </MenuWithDropdown>
              
              <MenuText
                pick={this.state.pick}
                onClick={() => {
                  this.setState({
                    pick: "NOTICE",
                  });
                  this.props.history.push("/notice");
                }}
              >
                NOTICE
              </MenuText>
              <MenuText
                pick={this.state.pick}
                onClick={() => {
                  this.setState({
                    pick: "ORGANIZATION",
                  });
                  this.props.history.push("/organization");
                }}
              >
                ORGANIZATION
              </MenuText>
            </MenuDiv>
          </NavBarRightContainer>
        </NavContent>
      </NavBarContainer>
    );
  }
}

const NavBarContainer = styled.div`
  display: flex;
  height: 80px; /* 고정 높이 설정 */
  width: 100%;
  z-index: 999;
  justify-content: center;
  align-items: center; /* 수직 가운데 정렬 */
  position: fixed; /* 고정 위치 설정 */
  top: 0; /* 화면 상단에 고정 */
  left: 0; /* 화면 왼쪽에 고정 */
  background-color: rgba(0, 0, 0, 0.85); /* 배경색 추가 (필요에 따라 조정) */
  @media (max-width: 768px) {
    height: 60px; /* 모바일에서 높이 조정 */
  }
`;

const NavContent = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  max-width: 1440px;
  height: 100%;
  align-items: center; /* 수직 가운데 정렬 */
  margin-left: 24px;
  margin-right: 24px;
  /* padding 제거하고 가운데 정렬로 변경 */
  @media (max-width: 768px) {
    min-width: 375px;
    max-width: 768px;
    margin-left: 0px;
    margin-right: 0px;
  }
`;

const MmenuImg = styled.img`
  @media (max-width: 768px) {
  }
`;

const ModelOverlay = styled.div`
  position: fixed;
  display: flex;
  z-index: 50;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: transparent;
  /* height: auto; */
  /* background-color: rgba(0, 0, 0, 0.5); */
  height: 668px;
`;

const MobileHalf = styled.div`
  display: flex;
  position: fixed;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
  width: 50%;
  /* height: 668px; */
  height: 100%;
  min-width: 180px;
  max-width: 768px;
  top: 0px;
  left: 0;
  right: 0;
  z-index: 100;
  right: 0;
  background-color: rgba(0, 0, 0, 0.85);
`;

const NavBarLeftContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-left: 110px;
  /* width: 50%; */
  @media (max-width: 768px) {
    margin-left: 9px;
    display: block;
  }
`;

const NavBarRightContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  margin-right: 85px;
  @media (max-width: 768px) {
    margin-right: 0px;
  }
`;

const GraLogoImg = styled.img`
  width: 100%;
  max-width: 144px;
  height: auto;
  max-height: 26px;
  cursor: pointer;
  @media (max-width: 768px) {
    max-width: 100px;
    cursor: pointer;
  }
`;

const ModalInGraLogoImg = styled.img`
  max-width: 92px;
  margin-bottom: 10px;
  margin-right: 39px;
`;

const MXmenuImg = styled.img`
  width: 100%;
  max-height: 14px;
  max-width: 14px;
`;

const ModalLine = styled.div`
  width: 146px;
  height: 0px;
  border: 0.8px solid rgba(255, 255, 255, 0.5);
  margin-bottom: 15px;
`;

const MImgDiv = styled.div`
  display: flex;
  flex-direction: row;
`;

const MobileMenuDiv = styled.div`
  display: none;
  @media (max-width: 768px) {
    display: flex;
    flex-direction: row;
    /* width: 100%; */
    justify-content: flex-start;
    text-decoration: none;
    margin-left: 26px;
  }
`;

const TempMenu = styled.div``;

const MenuDiv = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: flex-end;
  text-decoration: none;
  @media (max-width: 768px) {
    display: none;
  }
`;

const MenuText = styled.div`
  font-family: Noto Sans KR;
  font-style: normal;
  font-weight: ${(props) => (props.children === props.pick ? "800" : "500")};
  font-size: 16px;
  line-height: 22px;
  color: ${(props) =>
    props.children === props.pick ? "#ffffff" : "rgba(255, 255, 255, 0.5)"};
  margin-right: ${(props) =>
    props.children === "ORGANIZATION" ? "0px" : "51px"};
  cursor: pointer;
  @media (max-width: 768px) {
    display: none;
  }
`;

const MobileMenuText = styled.div`
  @media (max-width: 768px) {
    font-family: Noto Sans KR;
    font-style: normal;
    font-weight: ${(props) => (props.children === props.pick ? "800" : "500")};
    font-size: 16px;
    line-height: 22px;
    color: ${(props) =>
      props.children === props.pick ? "#ffffff" : "rgba(255, 255, 255, 0.5)"};
    margin-right: ${(props) =>
      props.children === "ORGANIZATION" ? "0px" : "51px"};
    margin-bottom: 18px;
    cursor: pointer;
  }
`;

const ModalMenuContainer = styled.div`
  display: flex;
  flex-direction: column;
  @media (max-width: 768px) {
    margin-top: 33px;
    margin-left: 25px;
  }
`;

const ModalMenuDiv = styled.div``;

// 새로 추가된 스타일 컴포넌트
const MenuWithDropdown = styled.div`
  position: relative;
  display: inline-block;
`;

const DropdownMenu = styled.div`
  position: absolute;
  top: 40px;
  left: 0;
  background-color: rgba(0, 0, 0, 0.9);
  border-radius: 4px;
  min-width: 180px;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
  z-index: 1000;
  overflow: hidden;
`;

const DropdownItem = styled.div`
  color: rgba(255, 255, 255, 0.8);
  font-family: Noto Sans KR;
  font-size: 14px;
  padding: 15px 20px;
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:hover {
    background-color: rgba(64, 72, 226, 0.7);
    color: #ffffff;
  }
`;

const MobileSubmenu = styled.div`
  margin-left: 20px;
  margin-bottom: 15px;
`;

const MobileSubmenuItem = styled.div`
  font-family: Noto Sans KR;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.7);
  margin-bottom: 12px;
  cursor: pointer;
  transition: color 0.3s ease;
  
  &:hover {
    color: #ffffff;
  }
`;

export const NavigationBarPage = withRouter(NavigationBarContainer);